import Typography from 'design-system/components/Typography/Typography';

export default function FloatingPostMenuHelper({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <Typography
      variant={'button2'}
      className="mt-1 text-center text-Primary/Main"
    >
      {children}
    </Typography>
  );
}
